import { render, staticRenderFns } from "./PhoneList.vue?vue&type=template&id=d85962c6&scoped=true&"
import script from "./PhoneList.vue?vue&type=script&lang=js&"
export * from "./PhoneList.vue?vue&type=script&lang=js&"
import style0 from "./PhoneList.vue?vue&type=style&index=0&id=d85962c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85962c6",
  null
  
)

export default component.exports